import { Provider } from 'root/src/shared/@types/providers';
import { DarePlatform, Platform } from 'root/src/shared/@types/platforms';
export const providerToPlatform = (provider) => {
    switch (provider) {
        case Provider.Twitch:
            return Platform.Twitch;
        case Provider.Google:
            return Platform.YouTube;
        case Provider.TikTok:
            return Platform.TikTok;
        default:
            throw new Error(`Unknown provider ${provider}`);
    }
};
export const platformToProvider = (platform) => {
    switch (platform) {
        case Platform.Twitch:
            return Provider.Twitch;
        case Platform.YouTube:
            return Provider.Google;
        case Platform.TikTok:
            return Provider.TikTok;
        default:
            throw new Error(`Unknown provider ${platform}`);
    }
};
export const platformsToViewershipPlatforms = (platforms) => {
    return platforms.flatMap((platform) => {
        if (platform === Platform.Twitch) {
            return [DarePlatform.Twitch];
        }
        if (platform === Platform.YouTube) {
            return [DarePlatform.YouTube, DarePlatform.YouTubeShorts];
        }
        if (platform === Platform.TikTok) {
            return [DarePlatform.TikTok];
        }
        return [];
    });
};
